import { render, staticRenderFns } from "./ViajesInfoPuntos.vue?vue&type=template&id=3843e69a"
import script from "./ViajesInfoPuntos.vue?vue&type=script&lang=js"
export * from "./ViajesInfoPuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports